module.exports = __webpack_public_path__ + "img/ic_pin_or.43957602.svg";